import React from 'react';
import { withTranslation } from 'react-i18next';
import { ReactMultiEmail } from 'react-multi-email';
import PropTypes from 'prop-types';

const MultiEmail = (props) => {
  const { input, placeholder } = props;

  return (
    <ReactMultiEmail
      emails={input.value}
      placeholder={placeholder}
      onChange={input.onChange}
      getLabel={(email, index, removeEmail) => {
        return (
          <div data-tag key={index}>
            {email}
            <button
              type="button"
              data-tag-handle
              onClick={() => removeEmail(index)}
            >
              ×
            </button>
          </div>
        );
      }}
    />
  );
};

MultiEmail.propTypes = {
  input: PropTypes.shape(PropTypes.shape),
  placeholder: PropTypes.string,
};

MultiEmail.defaultProps = {
  input: {
    value: [],
    onChange: null,
  },
  placeholder: '',
};

export default withTranslation('common')(MultiEmail);
